import {
  HomeOutlined,
  UnorderedListOutlined,
  UserOutlined,
  WalletOutlined,
} from "@ant-design/icons";
import { Col, Row } from "antd";
import "antd/dist/antd.css";
import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { apigetCredit } from "../../services/apis/profile";
import "./NavigationBar.css";

const NavigationBar = () => {
  const history = useHistory();
  const location = useLocation();
  const [credit, setCredit] = useState(
    localStorage.getItem("rondori_credit")
      ? localStorage.getItem("rondori_credit")
      : 0
  );
  const [user_id, setUserId] = useState(
    localStorage.getItem("rondori_id") ? localStorage.getItem("rondori_id") : 0
  );

  useEffect(() => {
    let intime1 = setInterval(() => {
      let token = localStorage.getItem("rondori_token");
      if (token) {
        getCreditUser();
      }
    }, 3000);

    return () => clearInterval(intime1);
  }, []);

  const getCreditUser = async () => {
    let creditUser = await apigetCredit();
    if (creditUser && creditUser.status) {
      setCredit(creditUser.result);
      localStorage.setItem("rondori_credit", creditUser.result);
      localStorage.setItem("rondori_id", creditUser.user_id);
    }
  };

  return (
    <div className="navigation-bar">
      <div className={`short-menu`}>
        <Row>
          <Col flex={2}>
            <div
              className={`bx-menu ${
                location.pathname === "/home" ? "active" : ""
              }`}
              onClick={(e) => {
                e.preventDefault();
                history.push("/home");
              }}
            >
              <HomeOutlined className="icon-menu" />
              <p className="menu-name">หน้าหลัก</p>
            </div>
          </Col>
          <Col flex={2}>
            <div
              className={`bx-menu ${
                location.pathname === "/history" ? "active" : ""
              } ${localStorage.getItem("rondori_token") ? "" : "disabled"}`}
              onClick={(e) => {
                e.preventDefault();
                history.push("/history");
              }}
            >
              <UnorderedListOutlined className="icon-menu" />
              <p className="menu-name">ประวัติ</p>
            </div>
          </Col>
          <Col flex={2}>
            <div
              className={`bx-menu ${
                location.pathname === "/wallets" ? "active" : ""
              } ${localStorage.getItem("rondori_token") ? "" : "disabled"}`}
              onClick={(e) => {
                e.preventDefault();
                history.push("/wallets");
              }}
            >
              <WalletOutlined className="icon-menu" />
              <p className="menu-name">เติมเงิน</p>
            </div>
          </Col>
          <Col flex={2}>
            <div
              className={`bx-menu ${
                location.pathname === "/about" ? "active" : ""
              }`}
              onClick={(e) => {
                e.preventDefault();
                history.push("/about");
              }}
            >
              <UserOutlined className="icon-menu" />
              <p className="menu-name">ฉัน</p>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default NavigationBar;
